import { getApiUrl } from '../../../Url';

type SignedUrlParameters = {
  filename: string;
  fileType: string;
};

type SignedUrlResponse = {
  fileKey: string;
  filename: string;
  requestUuid: string;
  signedUrl: string;
};

export async function fetchSignedUrl({
  filename,
  fileType,
}: SignedUrlParameters): Promise<SignedUrlResponse> {
  try {
    const response = await fetch(
      getApiUrl({
        path: `upload/signed_url`,
        queryParameters: { filename, type: fileType },
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (response.ok) {
      return response.json();
    }
    throw new Error(`Could not fetch signed url`);
  } catch (err) {
    throw new Error(err.message);
  }
}
